import './styles/main.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from './App.vue'
import router from './router'
import langPlugin from './plugins/lang'
import mobileBreakPlugin from './plugins/mobile-break'

const app = createApp(App)

app.use(createPinia())
app.use(router)
app.use(langPlugin)
app.use(mobileBreakPlugin)


app.mount('#app')
